/** @format */

import axios from 'axios'
import {ElLoading} from 'element-plus'

let loadingInstance
let loadingNum = 0 //  内存中正在请求的数量

function startLoading() {
    //  打开加载动画
    if (loadingNum == 0) {
        loadingInstance = ElLoading.service({
            fullscreen: true,
            text: '拼命加载中...',
            background: 'rgba(255, 255, 255, 0.5)',
        })
    }
    loadingNum++
}

//  关闭加载动画
function endLoading() {
    loadingNum--
    if (loadingNum <= 0) {
        loadingInstance.close()
    }
}

//使用create方法创建axios实例
const Service = axios.create({
    timeout: 20000, // 请求超时时间
})

// 添加请求拦截器
Service.interceptors.request.use(
    function (config) {
        // 在发送请求之前做些什么
        startLoading() //  打开加载动画
        return config
    },
    function (error) {
        console.log(error)
        // 对请求错误做些什么
        return Promise.reject(error)
    }
)

// 添加响应拦截器
Service.interceptors.response.use(
    function (response) {
        // 2xx 范围内的状态码都会触发该函数。
        // 对响应数据做点什么
        endLoading() //  关闭加载动画
        return response
    },
    function (error) {
        // 超出 2xx 范围的状态码都会触发该函数。
        // 对响应错误做点什么
        console.log(error)
        return Promise.reject(error)
    }
)

const getRequest = (url) => {
    return Service({
        url: url,
        method: 'get',
    })
}

const postRequest = (url, info) => {
    return Service({
        url: url,
        data: JSON.stringify(info),
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
    })
}


export {getRequest, postRequest}